module.exports = __webpack_public_path__ + "static/media/cotyBanner-tablet-738x57@1x.5c4bb80e.jpg";